'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class HeaderComponent {
  // constructor(title) {
  //   this.title = title;
  // }

}

export default angular.module('directives.header', [])
  .component('header', {
    template: require('./header.html'),
    controller: HeaderComponent,
    bindings: {
      title: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/header/header.component.js